import { useAuth } from "@/hooks/use-auth";
import slotToRange from "@/utils/date/to-range";
import { BuyerAvailability, getBuyerAvailability } from "@/utils/get-buyer-availability";
import { logger } from "@/utils/logger";
import React, { useEffect, useState } from "react";
import SlotSheetOverLay from "../common/slot-sheet-overlay";
import { PrefillSlotsComp } from "./prefill-slots-comp";
import { SlotVisit } from "./slot-visit";
import { MainProps, Slot } from "./types";

// Main Component
export default function Main(props: MainProps): React.ReactElement {
	const [isConfirmed, setIsConfirmed] = useState<boolean>(Boolean(props.isPrefilled));
	const [shouldFill, setShouldFill] = useState<boolean>(false);
	const { projectId, unitId, userId, buyerId: buId } = props;
	const { user } = useAuth();
	const [loading, setLoading] = useState(false);
	const [prefillData, setPrefillData] = useState<Slot[]>([]);
	const [currentUnitData, setCurrentUnitData] = useState<Slot[]>([]);
	const [counterSlots, setCounterSlots] = useState<Slot[]>([]);
	const buyerId =
		buId ||
		(user?.groups || []).find((group: { relationship: string; id: string }) => group.relationship === "buyer")?.id;

	const enabled = Boolean(userId) && Boolean(unitId) && Boolean(buyerId);

	useEffect(() => {
		if (enabled && buyerId) {
			const now = new Date();
			setLoading(true);
			getBuyerAvailability({
				buyerId,
				...(projectId ? { projectId } : { unitId }),
				isMobile: false,
			})
				.then((data: BuyerAvailability | { error: string }) => {
					if (data && !("error" in data)) {
						const { otherBuyerSlots, currentBuyerSlots, sellerSlots } = data as BuyerAvailability;
						const processSlots = (slots: { startTime: string; endTime: string }[]) => {
							if (!slots) return [];

							return slots
								.filter(slot => new Date(slot.startTime) > now)
								.map(slot => ({
									start: new Date(slot.startTime),
									end: new Date(slot.endTime),
								}));
						};

						// 3. Execute with clean calls
						setPrefillData(processSlots(otherBuyerSlots));
						setCurrentUnitData(processSlots(currentBuyerSlots));
						setCounterSlots(processSlots(sellerSlots));
					}
				})
				.catch(error => {
					logger.error("error fetching buyer availability", error);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [enabled, buyerId, projectId, unitId]);
	const allData = Array.from(
		new Map(
			[...(prefillData as Slot[]), ...(currentUnitData as Slot[])].map(item => [item.start.toString(), item]),
		).values(),
	);
	const parsedTimes = slotToRange(prefillData) || {};
	const dates = Object.keys(parsedTimes);

	const isOpen = Boolean(!isConfirmed && prefillData.length);
	return (
		<>
			<SlotSheetOverLay isOpen={isOpen} onClose={() => {}}>
				<PrefillSlotsComp
					dates={dates}
					handleConfirm={flag => {
						setShouldFill(flag);
						setIsConfirmed(true);
					}}
					parsedTimes={parsedTimes}
				/>
			</SlotSheetOverLay>
			<SlotVisit
				{...{
					...props,
					loading,
					counterSlots,
					prefill: shouldFill ? allData : currentUnitData,
				}}
			/>
		</>
	);
}
